//@flow
import Raven from 'raven-js'

import {setState} from '$util'
import {login, logout} from '$src/auth/reducers'
import amplitude from '$src/analytics/amplitude'

export type Payload = {id_token: string, refresh_token: string, email: string, uid: string}

export default function* setTokensState(payload?: Payload): Generator<*, *, *> {
  if (payload) {
    if (Raven.isSetup()) Raven.setUserContext({id: payload.uid})
    amplitude.setUserId(payload.uid)
    // $FlowIgnore
    return yield setState('auth', oldState => login(oldState, payload))
  } else {
    if (Raven.isSetup()) Raven.setUserContext() // Clears user context
    amplitude.setUserId(null)
    yield setState('auth', logout)
  }
}



// WEBPACK FOOTER //
// ./src/util/setTokensState.js